/**
 * The readiness outcome as a chip (docs/ux/registry.md): Ready (done tone,
 * check), Not decided (warning tone, pause), Blocked (error tone, x). One
 * vocabulary for the list, the page, the phone and the Report tab later;
 * `data-readiness` carries the outcome and the word is always in the chip.
 */

import { CheckIcon, CircleXIcon, PauseIcon } from 'lucide-react';
import type { ReadinessOutcome } from '@/app/types';
import { StateChip } from '@/components/matter/StateChip';
import { OUTCOME_TONE, OUTCOME_WORD } from './describe';

export function OutcomeIcon({ outcome, className = 'size-3.5' }: { outcome: ReadinessOutcome; className?: string }) {
  if (outcome === 'ready') return <CheckIcon aria-hidden="true" className={className} />;
  if (outcome === 'not_decided') return <PauseIcon aria-hidden="true" className={className} />;
  return <CircleXIcon aria-hidden="true" className={className} />;
}

export function ReadinessChip({ outcome, size = 'md', className }: { outcome: ReadinessOutcome; size?: 'sm' | 'md'; className?: string }) {
  return <StateChip label={OUTCOME_WORD[outcome]} tone={OUTCOME_TONE[outcome]} size={size} icon={<OutcomeIcon outcome={outcome} className={size === 'sm' ? 'size-3' : 'size-3.5'} />} attrs={{ 'data-readiness': outcome }} className={className} />;
}
